import { useCallback } from 'react';
import { inputStyle } from './TextInput.css';

type TextInputProps = {
  className?: string;
  onChange?: (v: string) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

export const TextInput: React.FC<TextInputProps> = ({ className, onChange, ...props }) => {
  return (
    <input
      className={[inputStyle, className].filter((x) => x).join(' ')}
      type="text"
      onChange={useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => onChange && onChange(e.target.value),
        [onChange],
      )}
      {...props}
    />
  );
};
